<script>
import { BBadge } from 'bootstrap-vue'
import {SubmissionStatus} from "@/libs/product";
export default {
    props: {
        submission: {
            required: true
        }
    },
    components: {BBadge},
    computed: {
        variant() {
            switch (this.submission.status) {
                case SubmissionStatus.ERROR:
                case SubmissionStatus.FAILED:
                case SubmissionStatus.ECHA_SERVER_ERROR:
                case SubmissionStatus.CHECK_STATUS_ATTEMPTS_EXCEEDED:
                    return 'danger';

                case SubmissionStatus.PENDING:
                case SubmissionStatus.UNDER_PROCESSING:
                    return 'warning';

                case SubmissionStatus.SUCCEEDED:
                case SubmissionStatus.NOTIFIED:
                    return 'success';
            }

            return 'primary';
        },
        translation() {
            return this.$t(SubmissionStatus.getTranslationKey(this.submission.status));
        },
    }
}
</script>

<template>
    <b-badge
        :variant="variant"
    >{{ translation }}</b-badge>
</template>
